module.exports = __webpack_public_path__ + "static/media/casting_nathan.5a09b0b6.jpg";